export const environment = {
    production: false,
    _auth_service: 'https://auth.nlf.no/auth',
    _logout_service: 'https://auth.nlf.no/logout',
    _client_id: 'kpkje0xssi48qosmk474',
    _scope: 'read',
    _shebang: 0,
    _response_type: 'access_token',
    _name: 'dev',
    _top_level_name: 'dev',
    _e5x_submission: true
};
